/* eslint-disable react/prop-types */
// added the above text for the sonarqube fix

import { useCallback, useState } from "react";

import {
  AIIcon,
  Button,
  CommonPopupCrud,
  FormControlLabel,
  IconButton,
  MuiTooltip,
  Radio,
  RadioGroup,
} from "@common";

import { useHostSelector } from "@hooks";
// ====================================================================================================
const CommonAiButton = ({
  tooltip,
  // openAIKey,
  name,
  handleClick,
  showChoose,
  disabled,
}) => {
  const openAIKeyState = useHostSelector(
    (state) => state?.openAI?.verifyOpenAI,
  );
  const openAIKey = openAIKeyState?.length > 0;
  const [showChooseOption, setShowChooseOption] = useState(false);
  const handleCheckSelect = useCallback(
    (e) => {
      if (openAIKeyState?.length > 1 && showChoose) {
        setShowChooseOption(true);
      } else {
        handleClick({ aiKey: openAIKeyState?.[0]?.apiKey });
      }
    },
    [setShowChooseOption, handleClick, openAIKeyState, showChoose],
  );

  return (
    <>
      <MuiTooltip title={tooltip ?? ""}>
        <IconButton
          disabled={!openAIKey || disabled}
          onClick={handleCheckSelect}
          {...(name ? {} : { variant: "contained" })}
            style={{
              padding: 0,
            }}
        >
          {name ? (
            <Button
              variant={"contained"}
              size="small"
              startIcon={
                <AIIcon className={"ai-generation-button-icon-color"} />
              }
              // className="ai-generation-color"
              className={
                !openAIKey || disabled
                  ? "ai-generation-color-disabled"
                  : "ai-generation-color"
              }
            >
              {name}
            </Button>
          ) : (
            <AIIcon greenColor={true} />
          )}
        </IconButton>
      </MuiTooltip>

      {showChooseOption && (
        <ChooseOption
          openAIKeyState={openAIKeyState}
          handleClick={handleClick}
          setShowChooseOption={setShowChooseOption}
          close={() => setShowChooseOption(false)}
        />
      )}
    </>
  );
};

export default CommonAiButton;

const ChooseOption = ({
  openAIKeyState,
  handleClick,
  setShowChooseOption,
  close,
}) => {
  const [selectedChoice, setSelectedChoice] = useState(
    openAIKeyState[0]?.apiKey,
  );
  const handleSubmit = useCallback(() => {
    handleClick({ aiKey: selectedChoice });
    setShowChooseOption(false);
  }, [selectedChoice, setShowChooseOption, handleClick]);

  const handleSelectChoice = useCallback(
    (e) => {
      const value = e.target.value;
      setSelectedChoice(value);
    },
    [setSelectedChoice],
  );

  return (
    <CommonPopupCrud
      heading="Choose AI to use"
      buttonAlignRight={true}
      alertSaveColor={true}
      saveText="Proceed"
      hideSaveAndNext={true}
      handleSubmit={handleSubmit}
      close={close}
      mediumScreen={true}
    >
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="aiKey"
        onChange={handleSelectChoice}
        // row
        // defaultValue={formik.values[item.name]}
        // tabIndex={7}
        className="res_radioMargin"
        style={{
          display: "flex",
          flexDirection: "row",
          marginLeft: "3rem",
        }}
        defaultValue={selectedChoice}
        value={selectedChoice}
      >
        {openAIKeyState?.map((item, i) => {
          return (
            <FormControlLabel
              key={item?.apiKey}
              // sx={{ width: "5rem" }}
              value={item?.apiKey}
              control={<Radio />}
              label={item?.name}
            />
          );
        })}
      </RadioGroup>
    </CommonPopupCrud>
  );
};
